import { Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { RoleState, RoleStateModel } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import {
  BaseCssProperties,
  DummyRole,
  ProviderClass,
  SwitchNavigatorQuickLinkWidgetConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-switch-navigator-quick-link-widget',
  templateUrl: './switch-navigator-quick-link-widget.component.html',
  styleUrls: ['./switch-navigator-quick-link-widget.component.scss'],
})
export class SwitchNavigatorQuickLinkWidgetComponent extends BaseComponent {
  widgetData: SwitchNavigatorQuickLinkWidgetConfig;
  textContentStyle: baseCssConfigStyle;
  pageUrlsData: {
    zone: string;
    pageUrl: string;
    pageId?: string;
    isActive: boolean;
    role: string;
  }[] = [];
  override attri: SwitchNavigatorQuickLinkWidgetConfig;
  override contentStyle: baseCssConfigStyle;
  activeSwitchStyle: baseCssConfigStyle;
  marginBorderStyle: baseCssConfigStyle;
  @Select(RoleState.getRole)
  roles!: Observable<RoleStateModel>;
  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<SwitchNavigatorQuickLinkWidgetConfig>,
  ) {
    super();
    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri ?? null;
      if (this.attri != null) {
        this.widgetData = this.dataIn.attri;
        this.setPageUrlData(this.dataIn);
      }
    }

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.PADDING,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.BOX_SHADOW,
      BaseCssProperties.TEXT_BOLD,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_UNDERLINE,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_FONT_STYLE,
    ]);
    this.marginBorderStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.BORDER,
      BaseCssProperties.MARGIN,
      BaseCssProperties.BOX_SHADOW,
    ]);
    const nonActiveSwitchColor = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.DISABLE_BACKGROUND_COLOR,
      BaseCssProperties.DISABLE_COLOR,
    ]);
    const activeSwitchColor = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.COLOR,
    ]);
    this.contentStyle = {
      ...this.contentStyle,
      ...nonActiveSwitchColor,
    };
    this.activeSwitchStyle = {
      ...this.contentStyle,
      ...activeSwitchColor,
    };
  }

  private setPageUrlData(dataIn: ProviderClass<SwitchNavigatorQuickLinkWidgetConfig>) {
    this.checkForDummyRole();
    let pageUrl: string | undefined = '';
    dataIn.attri?.linksList.forEach((item) => {
      pageUrl = item.pageUrl;
      this.pageUrlsData.push({
        role: dataIn.attri?.role,
        zone: item.zone,
        pageUrl: `/zones/${formatNameAsUrl(item.zone)}/${pageUrl}`,
        pageId: item?.pageId,
        isActive: false,
      });
      pageUrl = '';
    });
  }

  checkForDummyRole() {
    if (this.dataIn?.attri?.role === DummyRole.EMPTY_ROLE) {
      this.roles
        .subscribe((roleInfo) => {
          this.dataIn.attri.role = roleInfo.role;
        })
        .unsubscribe();
    }
  }
}
